import { Theme } from '@mui/material';

/**
 * Where this app deviates from MUI's stacking scale, and why.
 *
 * MUI intends `appBar 1100 < drawer 1200 < modal 1300 < snackbar 1400 < tooltip 1500`, and relies
 * on dialogs and the overlays opened from inside them sharing `modal` so DOM order decides. Our
 * header is fixed and has to sit over the side nav, so it goes just above `drawer` — but it must
 * stay below `modal`, or every dialog needs lifting over it and every Select menu, Menu and
 * Autocomplete popper then renders behind the dialog it belongs to.
 */
export const appBarZIndex = (theme: Theme) => theme.zIndex.drawer + 1;

/** The collapsed nav's flyout, which opens over the header. */
export const navFlyoutZIndex = (theme: Theme) => theme.zIndex.drawer + 2;

/**
 * A Popper opened from inside a dialog. Unlike a Select menu — which is itself a MUI Modal and so
 * stacks against other modals — a Popper is given the same `zIndex.modal` as the dialog it belongs
 * to, leaving DOM order to break the tie. One above, so it does not depend on mount ordering.
 */
export const popperInDialogZIndex = (theme: Theme) => theme.zIndex.modal + 1;
